import React, {useEffect} from 'react';
import {observer} from "mobx-react-lite";
import {reaction} from "mobx";
import {BottomNavigationBarComponent} from "../../bottom-navigation-bar/bottom-navigation-bar.component";
import {VideoSlidesArenaBox} from "./boxes/video-slides-arena.box";
//import {VideoSlidesContentArena} from "./video-slides-arena-content/video-slides-arena-content.component";
import {VideoSlidesHeaderArena} from "./video-slides-arena-header/video-slides-arena-header.component";
import {useServices} from '../../../react-hooks/use-services.hook';
import {VideoSlidesArenaSwiperComponent} from "./video-slides-arena-swiper/video-slides-arena-swiper.component";

export const VideoSlidesArena: React.FC = observer(() => {
    const services = useServices();

    useEffect(() => {
        const reactionDispose = reaction(() => services.videoSlides.shouldBeDisplayed,
            (shouldBeDisplayed) => {
                if (!shouldBeDisplayed) {
                    services.location.goHome();
                }
            }, {
            fireImmediately: true
        })

        return () => {
            reactionDispose();
        }
    }, [services.location, services.videoSlides.shouldBeDisplayed]);



    return (
        <VideoSlidesArenaBox>
            <VideoSlidesHeaderArena />
            <VideoSlidesArenaSwiperComponent/>
            <BottomNavigationBarComponent isInVideoSlidesArena={true} />
        </VideoSlidesArenaBox>
    );
})